import React, { PropsWithChildren, ReactNode } from 'react';

import { SectionContainer, SectionHeader, SectionTitle } from './styles';

interface SectionProps {
	title: string;
	rightSection?: ReactNode | JSX.Element;
	opacityLastBar?: boolean;
}

const Section = ({
	children,
	title,
	rightSection,
	opacityLastBar,
}: PropsWithChildren<SectionProps>) => {
	return (
		<SectionContainer $opacity={opacityLastBar}>
			<SectionHeader>
				<SectionTitle>{title}</SectionTitle>
				{rightSection}
			</SectionHeader>
			{children}
		</SectionContainer>
	);
};

export { Section };
